import {ToTopOutlined} from '@ant-design/icons'
import IconWithNotification from '../../../SidePanel/LeftPanel/IconWithNotification.jsx'
import UpgradeRefPane from './UpgradeRefPane.jsx'
import useUpgradableItems from './useUpgradableItems.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const items = useUpgradableItems()

    if ('CHG_REFERENCE_MAP' !== map.data.mapTypeCode) {
        return null
    }

    return {
        icon: (
            <IconWithNotification notification={0 < items.length}>
                <ToTopOutlined />
            </IconWithNotification>
        ),

        key: 'upgrade',
        name: '升级模件',
        pane: <UpgradeRefPane items={items} />,
    }
}
